/**
 * Loading required JS scripts and plugins such as jQuery and Bootstrap
 */

window._ = require('lodash');
import { createPopper } from '@popperjs/core';
window.$ = window.jQuery = require('jquery');
//require('bootstrap');
window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');
require('es6-promise').polyfill();

/**
 * Loading theme JS plugins
 */

window.moment = require('moment');

require('slick-carousel');

// Require inputmask using jquery
require("inputmask/dist/inputmask/jquery.inputmask");
require("inputmask/dist/inputmask/inputmask.date.extensions");
window.Inputmask = require('inputmask');

require("./theme-shared");

import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox.js";

// Import Malihu Custom Scrollbar
require('malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js');
require('malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.js');